module.exports = __webpack_public_path__ + "img/logo1h.f7e5892e.png";